import { skipToken } from '@reduxjs/toolkit/query/react';
import type { ConversationNodeIntentDetection } from 'lib-shared-types-api';

import { intentDetectionApi } from 'apis/intentDetection';

type RoutedThroughIntentDetectionProps = {
  node: ConversationNodeIntentDetection;
};

export function RoutedThroughIntentDetection({
  node,
}: RoutedThroughIntentDetectionProps): JSX.Element {
  const { data } = intentDetectionApi.useReadIntentDetectionQuery(
    node.matching_intent_id ? { id: node.matching_intent_id } : skipToken,
  );

  const intentName = data?.name;

  return (
    <>
      Intent detection{' '}
      {intentName && (
        <>
          · <strong> {intentName} </strong>
        </>
      )}
    </>
  );
}
